module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Regular.8a4769a3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Regular.ttf
// module id = 334
// module chunks = 3